import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import CustomSelect from '../../../components/CustomSelect';
import DefaultTooltip from '../../../components/DefaultTooltip';
import { ControlpanelSecondaryButton, ControlpanelSuccessButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useSettings } from '../../../context/SettingsContext';

const ReEvaluateDialog = ({ onClose, selectedDate }) => {
   const { t } = useTranslation();
   const { settings } = useSettings();
   const formattedDate = format(selectedDate, settings.dateFormat);

   const handleCloseDialog = () => {
      onClose();
   };

   const [selectTheStrategy, setSelectTheStrategy] = useState('re-order');

   const handleChangeValue = (event) => {
      setSelectTheStrategy(event.target.value);
   };

   const selectTheStrategyData = [
      { value: 're-order', label: 'Re-order check-in check-out pair' },
      { value: 'first-and-last', label: 'First check-in and last check-out' },
   ];

   return (
      <CustomDialog open maxWidth={'sm'} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold text-[#1A1D1F]'>Re-evaluate eventlogs - {formattedDate}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            <div className='flex items-center pt-5 gap-5 justify-between flex-wrap'>
               <div className='flex items-center gap-2'>
                  <p>Select the strategy</p>
                  <DefaultTooltip
                     readMore={false}
                     title='Re-evaluate strategy'
                     content={
                        <div className='flex flex-col gap-3'>
                           <p>Re-order: Automatically add a checkout event, if auto checkout enabled.</p>
                           <p>
                              First and last: Mark first event as check-in, last event as check-out, and rest of the events as access
                              events.
                           </p>
                        </div>
                     }
                  >
                     <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
                  </DefaultTooltip>
               </div>
               <CustomSelect
                  name='selectTheStrategy'
                  value={selectTheStrategy}
                  onChange={handleChangeValue}
                  options={selectTheStrategyData}
                  className='max-w-72'
               />
            </div>
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelSuccessButton>
                  <CheckIcon />
                  <p>{t('button.re-evaluete')}</p>
               </ControlpanelSuccessButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default ReEvaluateDialog;
